// extracted by mini-css-extract-plugin
export default {"hold":"styles_hold__zHKHc","finished":"styles_finished__Ws3Ho","start":"styles_start__pNWyY"};